'use strict';
import { themeService } from '../services/theme/ThemeService';
import AuthStore from '../store/authenticationStore';
var configPromise = require('../config').configPromise;
var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

var AppApi = require('./../api/appApi');

/**
 * @callback NotifyCallback
 * @param {string} message
 * @param {string} title
 * @param {NotificationMetaDataExtraData} additionalViewData
 */

var AppAction = {

  setPopover: function (event, element) {
    event.stopPropagation();

    Dispatcher.dispatch({
      actionType: ActionType.APP_OPEN_POPOVER,
      popover: ReactDOM.findDOMNode(element)
    })
  },

  setLayoutOrientationByLanguage: async (langCode) => {
    const config = await configPromise;
    themeService.rtl = config.isRtlLang(langCode);
  },

  getLanguageFromToken: (token) => {
    return token && token.Language || null;
  },

  setLanguage: async (langCode) => {
    Dispatcher.dispatch({
      actionType: ActionType.APP_CHANGE_LANG,
      code: langCode
    });
  },

  toggleGlobalSpinner(state) {
    Dispatcher.dispatchAsync({ actionType: ActionType.APP_TOGGLE_GLOBAL_SPINNER, state });
  },

  toggleInProgressState(disabled, id) {
    Dispatcher.dispatch({ actionType: ActionType.APP_TOGGLE_IN_PROGRESS_STATE, state: { disabled, id } })
  },

  getAvailableLanguages(){
    return AppApi.getLanguages().then(function (lang) {
      Dispatcher.dispatch({
        actionType: ActionType.APP_LOAD_LANGUAGES,
        languages: lang.langList,
        defaultLang: lang.defaultLang
      });
    });
  },

  /** @type {NotifyCallback} */
  notifyError(message, title, additionalViewData) {
    Dispatcher.dispatch({ actionType: ActionType.SHOW_ERROR_NOTIFICATION, message, title, additionalViewData });
  },

  /** @type {NotifyCallback} */
  notifySuccess(message, title, additionalViewData) {
    Dispatcher.dispatchAsync({ actionType: ActionType.SHOW_SUCCESS_NOTIFICATION, message, title, additionalViewData });
  },

  /** @type {NotifyCallback} */
  notifyInfo(message, title, additionalViewData) {
    Dispatcher.dispatch({ actionType: ActionType.SHOW_INFO_NOTIFICATION, message, title, additionalViewData });
  },

  /** @type {NotifyCallback} */
  notifyWarning(message, title, additionalViewData) {
    Dispatcher.dispatch({ actionType: ActionType.SHOW_WARNING_NOTIFICATION, message, title, additionalViewData });
  },

  setModuleState(state = false) {
    Dispatcher.dispatch({ actionType: ActionType.APP_MODULE_STATE, state });
  },

  openUrlInSeparateTab(url) {
    AuthStore.saveTokenToLocalStorage();
    const { protocol, hostname, port } = window.location;
    const appUrl = protocol + '//' + hostname + (port ? ':' + port : '');
    const fullCustomUrl = `${appUrl}${url}`;
    window.open(fullCustomUrl, '_blank');
  }

};

module.exports = AppAction;
